import { useState, useEffect, useRef, useContext } from "react";
import style from "./EventItem.module.scss";
import { v4 } from "uuid";
import ImageLoader from "../../comm/global/components/ImageLoader";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FriendsIcon from "../../comm/global/components/FriendsIcon";
import * as YStyled from "../../Styleds";
import { GameContext } from "../../GameContext";
const EventItem = ({ vo, set_events, addModalType }) => {
    const { userData } = useContext(GameContext);
    useEffect(() => {
        console.log("vo", vo.rewildingObj)
    }, []);
    return (
        <div className={style.app}>
            <YStyled.BackgroundDiv img={vo.events_photo} className={style.photo}>
                <div className={style.date}>
                    <div className={style.month}>
                        <YStyled.Span size={12}>{vo.events_date.toZH().month}</YStyled.Span>
                    </div>
                    <div className={style.day}>
                        <YStyled.Span size={20} fontWeight={400}>{vo.events_date.toZH().day}</YStyled.Span>
                    </div>
                </div>
                {vo.events_payment_fee > 0 &&
                    <div className={style.price}>
                        <YStyled.Span size={14}>${vo.events_payment_fee}</YStyled.Span>
                    </div>
                }
            </YStyled.BackgroundDiv>
            <div className={style.info}>
                <YStyled.Span size={17} style={{ padding: ".4rem 0" }} fontWeight={700}>{vo.events_name}</YStyled.Span>
                <YStyled.Span size={13} color="#6c6c6c" style={{ padding: ".4rem 0" }} fontWeight={400}>{vo.rewildingObj.rewilding_location?.join(" ")}</YStyled.Span>
                <YStyled.Row align="flex-start" gap=".5rem">
                    <ImageLoader variant={"circular"} style={{ width: "2rem", height: "2rem", borderRadius: "50%" }} src={vo.events_created_by_user.user_avatar} />
                    <YStyled.Span size={16} fontWeight={400}>{vo.events_created_by_user.user_name}</YStyled.Span>
                </YStyled.Row>
                <div className={style.bottom}>
                    <FriendsIcon users={vo.events_participants.latest_tree_user} remain_number={vo.events_participants.remain_number} />
                    <div className={style.view} onClick={e => {
                            addModalType({
                                cls: "EventDetail", arg: {
                                    cb: () => {
                                    },
                                    vo: vo,
                                    set_events: set_events
                                }
                            })
                    }}>
                        <YStyled.Span size={15} fontWeight={700}>查看</YStyled.Span>
                        <ArrowForwardIosIcon style={{ width: "1.2rem" }} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EventItem;